(function() {
  'use strict';

  // Prevent duplicate initialization
  if (window.expandableContentInitialized) {
    return;
  }
  window.expandableContentInitialized = true;

  // Use event delegation so dynamically rendered snippets also work
  document.addEventListener('click', function(event) {
    const toggle = event.target.closest('.expandable-content__toggle');
    if (!toggle) return;

    const container = toggle.closest('.expandable-content');
    if (!container) return;

    const truncated = container.querySelector('.expandable-content__text-truncated');
    const full = container.querySelector('.expandable-content__text-full');

    if (!truncated || !full) return;

    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    const readMoreLabel = toggle.getAttribute('data-read-more') || 'Mehr lesen';
    const readLessLabel = toggle.getAttribute('data-read-less') || 'Weniger lesen';

    if (isExpanded) {
      // Collapse to truncated text
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = readMoreLabel;
      full.classList.add('hidden');
      truncated.classList.remove('hidden');
    } else {
      // Expand to full text
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = readLessLabel;
      full.classList.remove('hidden');
      truncated.classList.add('hidden');
    }
  });
})();